export const defaultStakes = ["5", "10", "20", "50", "100", "200", "500"];
